import { render, staticRenderFns } from "./BottomNavDesktop.vue?vue&type=template&id=59ae3b08"
import script from "./BottomNavDesktop.vue?vue&type=script&lang=js"
export * from "./BottomNavDesktop.vue?vue&type=script&lang=js"
import style0 from "./BottomNavDesktop.vue?vue&type=style&index=0&id=59ae3b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports